<template>
  <generic-modal
    v-if="showPopup"
    :height="locationPermissionPopup.height"
    :width="locationPermissionPopup.width"
    :modalClass="'full-screen-popup lg-screen-centered my-address-modal-container'"
    :contentScroll="false"
    :background="'transparent'"
    :backgroundBody="'white'"
    :animationStyle="'slide-up-stick-bottom'"
    :zIndex="99998"
    @close="closeLocationPermissionPopup($event, '')"
  >
    <template v-slot:header>
      <div>
        <img
          :src="staticImgBaseUrl + '/images/global/handle-bg.svg'"
          class="handle-bg"
        /></div
    ></template>
    <template v-slot:body>
      <div>
        <div class="flex-column align-items-center p16">
          <div v-if="modulePropsData?.locIcon">
            <img :src="modulePropsData?.locIcon" />
          </div>
          <div class="fs-18 fw-700">{{ modulePropsData?.title }}</div>
          <div class="fs-14 color-slaty tc">
            {{ modulePropsData?.subTitle }}
          </div>
          <button
            class="btn bold secondary mt20 fw-700 width100"
            v-if="getPrimaryCTAText"
            @click="showLocationAccessBlockedModal"
          >
            {{ getPrimaryCTAText }}
          </button>
          <button
            class="btn bold primary mt12 fw-700 width100 ellips"
            @click="
              onSecondaryCTACloseDialog
                ? closeLocationPermissionPopup(e, getSecondaryCTAText)
                : continueWithSelectedLocation(e)
            "
            v-if="getSecondaryCTAText"
          >
            {{ getSecondaryCTAText }}
          </button>
        </div>
        <div
          v-if="lastSelectedAddress && isOnHomePage && showLastSelectedAddress"
        >
          <div class="gradient-stroke">OR</div>
          <div class="d-flex align-items-center justify-content-between plr16">
            <span class="fs-16 fw-700">Select from saved addresses</span
            ><span
              class="fs-12 fw-800 color-teal-primary"
              @click="goToAddressScreen"
              >View All <i class="hkfi-arrow-line pl5"></i
            ></span>
          </div>
          <div
            class="d-flex p16 align-items-start"
            @click="selectLastSelectedAddress"
          >
            <img v-if="getIconImgSrc" :src="staticImgBaseUrl + getIconImgSrc" />
            <div class="flex-column pl12">
              <div class="fs-14">
                {{ getTitle }}
                <span class="last-selected">LAST SELECTED</span
                ><i class="hkfi-arrow-line pl5 fs-12"></i>
              </div>
              <span class="fs-12 color-slaty">{{ getSubTitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer> </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import addressIcons from "../assets/addressIcons.json";
import { SavedAddressesListKeys } from "../helpers/addressConstants";
import { keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";
import {
  EVENT_LOCATION_BOTTOM_DRAWER_VIEW,
  EVENT_LOCATION_BOTTOM_DRAWER_ACTION,
} from "../helpers/analyticsEvents";

export default {
  name: "LocationPermissionPopup",
  components: {
    GenericModal,
  },
  props: ["moduleProps", "propsData"],
  data() {
    return {
      locationPermissionPopup: {
        height: "100vh",
        width: "100%",
      },
      modulePropsData: {},
      staticImgBaseUrl,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.initializeShowPopup();
  },
  methods: {
    closeLocationPermissionPopup(e, closeText) {
      if (this.isOnHomePage) {
        LocalStorageFunc.locPermisPopupDisabledHome();
      }
      EVENT_LOCATION_BOTTOM_DRAWER_ACTION({
        userAction: "Click",
        sectionPosition: 2,
        positionWithinSection: 1,
        category: closeText ? closeText : "Close location nudge",
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
        false
      );
    },
    goToAddressScreen() {
      Utility.sendToMyAddressPage();
    },
    selectLastSelectedAddress() {
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_USER_ADDRESS,
        this.lastSelectedAddress
      );
      LocalStorageFunc.setLocalStorageValue(
        "selectedAddress",
        this.lastSelectedAddress
      );
      let pos = {
        lat: this.lastSelectedAddress.latitude,
        lng: this.lastSelectedAddress.longitude,
      };
      let position = {
        coords: {
          latitude: pos.lat,
          longitude: pos.lng,
        },
        redirectTo: Utility.reloadPage,
        homePageAddress: {
          topAddress: this.lastSelectedAddress.customer_address_name,
          bottomAddress: this.lastSelectedAddress.formatted_address,
        },
      };
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, position);

      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
        false
      );
    },
    showLocationAccessBlockedModal() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true
      );
      EVENT_LOCATION_BOTTOM_DRAWER_ACTION({
        userAction: "Allow location from nudge",
        sectionPosition: 2,
        positionWithinSection: 1,
        category: "enable location CTA",
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
        false
      );
    },
    continueWithSelectedLocation() {
      const loc = LocalStorageFunc.getLastLocationNew()?.[0]?.location;
      const pos = {
        lat: loc.latitude,
        lng: loc.longitude,
      };
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_LOCATION, pos);
      EVENT_LOCATION_BOTTOM_DRAWER_ACTION({
        userAction: "Click",
        sectionPosition: 2,
        positionWithinSection: 1,
        category: this.getSecondaryCTAText,
      });

      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
        false
      );
      if (Utility.isRedirectedFromUrl("/cart-unified")) {
        Utility.sendToCartScreen();
      } else {
        Utility.sendToHomepageScreen();
      }
    },
    initializeShowPopup() {
      const isLocationNotAvailable =
        !LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;

      if (this.isOnHomePage) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_ALTERNATE_LOCATION_PERMISSION_MODAL,
          !LocalStorageFunc.getLocPermisPopupDisabledHome() &&
            isLocationNotAvailable &&
            !this.showFetchLocationModal &&
            !LocalStorageFunc.getIsLocationPermisssionGiven() &&
            !this.isSavedAddressSelected
        );
      }
    },
  },
  watch: {
    showPopup: {
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          EVENT_LOCATION_BOTTOM_DRAWER_VIEW();
        }
      },
    },
  },
  computed: {
    showPopup() {
      return (
        this.$store.state.Location.showAlternateLocationPermissionModal &&
        !this.$store.state.Location.isLocationPermissionGiven
      );
    },
    showLastSelectedAddress() {
      return this.$store.state.Location.alternateLocationPopupData
        .showLastSelectedAddress;
    },
    lastSelectedAddress() {
      return this.$store.getters[
        keyMapsGetter.GET_REARRANGED_SAVED_ADDRESS
      ]()?.[0];
    },
    getIconImgSrc() {
      return (
        addressIcons?.[this.lastSelectedAddress?.customer_address_name]
          ?.iconImgSrc || addressIcons["Other"]?.iconImgSrc
      );
    },
    getTitle() {
      return this.lastSelectedAddress[SavedAddressesListKeys.mainTextKey];
    },
    getSubTitle() {
      return this.lastSelectedAddress[SavedAddressesListKeys.subTextKey];
    },
    getPrimaryCTAText() {
      return this.$store.state.Location.alternateLocationPopupData
        ?.primaryCTAText?.length
        ? this.$store.state.Location.alternateLocationPopupData?.primaryCTAText
        : this.lastSelectedAddress && this.isOnHomePage
        ? "Enable Location Access"
        : "Enable Device Location";
    },
    getSecondaryCTAText() {
      const lastLocation =
        LocalStorageFunc.getLastLocationNew()?.[0]?.recent?.homePageAddress;
      if (
        this.$store.state.Location.alternateLocationPopupData?.secondaryCTAText
          ?.length
      ) {
        return this.$store.state.Location.alternateLocationPopupData
          ?.secondaryCTAText;
      } else if (
        (this.isOnHomePage &&
          !this.lastSelectedAddress &&
          lastLocation?.topAddress) ||
        (!this.isOnHomePage && lastLocation?.topAddress)
      ) {
        return `Continue With ${lastLocation.topAddress}`;
      } else return "";
    },
    isOnHomePage() {
      return Utility.isCurrentlyAtUrl("/store");
    },
    showFetchLocationModal() {
      return this.$store.state.Location.showFetchLocationModal;
    },
    onSecondaryCTACloseDialog() {
      return this.$store.state.Location.alternateLocationPopupData
        ?.onSecondaryCTACloseDialog;
    },
    isSavedAddressSelected(){
      return this.$store.state.User.selectedSavedAddress?.address_id
    }
  },
};
</script>
